package org.zq.astrock_ai.ui.research.gushi.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import kotlinx.coroutines.launch
import org.zq.astrock_ai.api.dto.LicenseRedeemResponseDto
import org.zq.astrock_ai.network.MarketApiClient
import org.zq.astrock_ai.ui.research.gushi.StockColors
import org.zq.astrock_ai.ui.research.gushi.adaptiveDialogWidth
import org.zq.astrock_ai.ui.research.gushi.data.DeviceLicenseStore

@Composable
fun RecommendLicenseDialog(
    hint: String = "",
    onDismiss: () -> Unit,
    onUnlocked: (LicenseRedeemResponseDto) -> Unit,
) {
    val api = remember { MarketApiClient() }
    val scope = rememberCoroutineScope()
    var code by remember { mutableStateOf("") }
    var error by remember { mutableStateOf(hint) }
    var loading by remember { mutableStateOf(false) }
    val fieldColors = OutlinedTextFieldDefaults.colors(
        focusedTextColor = StockColors.TextPrimary,
        unfocusedTextColor = StockColors.TextPrimary,
        focusedBorderColor = StockColors.PrimaryBlue,
        unfocusedBorderColor = StockColors.Border,
        cursorColor = StockColors.PrimaryBlue,
        focusedLabelColor = StockColors.TextSecondary,
        unfocusedLabelColor = StockColors.TextSecondary,
        focusedContainerColor = Color.White,
        unfocusedContainerColor = Color.White,
    )
    val shape = RoundedCornerShape(14.dp)

    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .adaptiveDialogWidth(380.dp)
                .background(Color.White, shape)
                .border(BorderStroke(1.dp, StockColors.Border), shape)
                .padding(20.dp),
        ) {
            Text(
                "开通智启荐股",
                color = StockColors.TextPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 17.sp,
            )
            Spacer(Modifier.height(6.dp))
            Text(
                "请输入一次性认证码。核销后绑定本机，到期后需再输入新码；同一设备再次核销会在剩余时间上续期。",
                color = StockColors.TextSecondary,
                fontSize = 12.sp,
            )
            Spacer(Modifier.height(14.dp))
            OutlinedTextField(
                value = code,
                onValueChange = {
                    code = it.uppercase().filter { ch -> ch.isLetterOrDigit() || ch == '-' }.take(16)
                    error = ""
                },
                label = { Text("认证码（如 A7-XXXXXX）") },
                singleLine = true,
                enabled = !loading,
                keyboardOptions = KeyboardOptions(capitalization = KeyboardCapitalization.Characters),
                colors = fieldColors,
                modifier = Modifier.fillMaxWidth(),
            )
            if (error.isNotBlank()) {
                Spacer(Modifier.height(8.dp))
                Text(error, color = StockColors.UpRed, fontSize = 12.sp)
            }
            Spacer(Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth()) {
                OutlinedButton(
                    onClick = onDismiss,
                    enabled = !loading,
                    modifier = Modifier.weight(1f),
                ) {
                    Text("取消")
                }
                Spacer(Modifier.width(8.dp))
                Button(
                    onClick = {
                        if (code.length < 6) {
                            error = "请输入认证码"
                            return@Button
                        }
                        loading = true
                        error = ""
                        scope.launch {
                            val result = runCatching {
                                api.redeemLicense(code, DeviceLicenseStore.deviceId())
                            }.getOrElse {
                                LicenseRedeemResponseDto(success = false, message = "网络异常，请稍后重试")
                            }
                            loading = false
                            if (result.success && result.token.isNotBlank()) {
                                DeviceLicenseStore.save(
                                    token = result.token,
                                    plan = result.plan,
                                    planLabel = result.planLabel,
                                    expiresAtMs = result.expiresAtMs,
                                    expiresAtLabel = result.expiresAtLabel,
                                )
                                onUnlocked(result)
                            } else {
                                error = result.message.ifBlank { "认证码无效或已被使用" }
                            }
                        }
                    },
                    enabled = !loading,
                    modifier = Modifier.weight(1f),
                    colors = ButtonDefaults.buttonColors(containerColor = StockColors.PrimaryBlue),
                ) {
                    Text(if (loading) "核销中…" else "开通")
                }
            }
        }
    }
}
